export default __webpack_public_path__ + "static/media/img2.7b8fc5cb.png";